import { useState, useEffect, useCallback } from "react";
import { qrGetRoomMembersFn } from "../firebase";
import { Member } from "../types";

export function useMembers(roomCode: string | null, user: any) {
  const [members, setMembers] = useState<Member[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchMembers = useCallback(async () => {
    if (!roomCode || !user) return;

    setLoading(true);
    setError(null);
    try {
      const result: any = await qrGetRoomMembersFn({ code: roomCode });
      setMembers(result.members || []);
    } catch (err: any) {
      console.error("Error fetching members:", err);
      setError(err.message || "Failed to load members");
      setMembers([]);
    } finally {
      setLoading(false);
    }
  }, [roomCode, user]);

  useEffect(() => {
    if (roomCode && user) {
      fetchMembers();
      
      // Refresh members every 30 seconds
      const interval = setInterval(fetchMembers, 30000);
      return () => clearInterval(interval);
    }
  }, [roomCode, user, fetchMembers]);

  return { members, loading, error, refetch: fetchMembers };
}

